import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";

const KEEP = "keep";

export default function FacilityBulkBar({ selected, hidden = 0, types, onDone, onClear }) {
  const [type, setType] = useState(KEEP);
  const [collect, setCollect] = useState(KEEP);
  const [access, setAccess] = useState(KEEP);
  const apply = async () => {
    const body = { codes: selected };
    if (type !== KEEP) body.type = type;
    if (collect !== KEEP) body.collect_ssn = collect === "yes";
    if (access !== KEEP) body.ssn_access = access;
    try {
      const { data } = await api.patch("/practice/facilities", body);
      toast.success(`${data.updated} facilities updated (audited)`);
      setType(KEEP); setCollect(KEEP); setAccess(KEEP); onDone();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const sel = (v, set, items, tid, w = "w-52") => (
    <Select value={v} onValueChange={set}><SelectTrigger className={`h-9 bg-white ${w}`} data-testid={tid}><SelectValue /></SelectTrigger>
      <SelectContent><SelectItem value={KEEP}>Keep as is</SelectItem>{items.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent></Select>
  );
  return (
    <div className="sticky top-0 z-10 flex flex-wrap items-center gap-2 rounded-xl border border-indigo-200 bg-indigo-50 p-3 shadow-sm" data-testid="facility-bulk-bar">
      <b className="text-sm text-indigo-900" data-testid="facility-bulk-count">{selected.length} selected{hidden ? ` (${hidden} hidden by filter)` : ""}</b>
      <Button size="sm" variant="ghost" className="h-8" onClick={onClear} data-testid="bulk-clear">Clear selection</Button>
      {sel(type, setType, types, "bulk-type")}
      {sel(collect, setCollect, [["yes", "Collect SSN"], ["no", "Do not collect SSN"]], "bulk-collect-ssn", "w-48")}
      {sel(access, setAccess, [["admins", "SSN: organization admins only"], ["editors", "SSN: any staff who can edit patients"]], "bulk-ssn-access", "w-64")}
      <Button className="btn-brand h-9" disabled={!selected.length || (type === KEEP && collect === KEEP && access === KEEP)} onClick={apply} data-testid="bulk-apply">Apply to selected</Button>
    </div>
  );
}
